export default [
    { type: 0, name: 'Cash' },
    { type: 1, name: 'Credit Card' },
    { type: 2, name: 'Cheque' },
    { type: 3, name: 'Voucher' },
    { type: 4, name: 'Others' },
];



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/setting/payment/create-payment-types.js